import type { RadioComponent } from 'services/content/components/types/FormModule'
import RequiredField from 'ui-component-library/components/00-Primitives/RequiredField'
import Radio from 'ui-component-library/components/00-Primitives/Inputs/Radio'

import style from './style.scss'

type Props = {
  component: RadioComponent
  onChange: (value: string) => void
  value: string
}

function FormModuleRadio({ component, onChange, value }: Props) {
  const { fieldId, options, labelText, isRequired, errorText } = component.props

  return (
    <fieldset>
      <legend className={style.label}>
        {labelText}
        {isRequired && <RequiredField />}
      </legend>
      <div className={style.options}>
        {options.map((option, index) => (
          <Radio
            key={`${option.value}_${index}`}
            checked={value === option.value}
            className={style.radio}
            errorText={errorText}
            handleOptionChange={onChange}
            inputId={`${fieldId}-${option.value}`}
            isRequired={isRequired}
            name={fieldId}
            value={option.value}
          >
            <span className={style.radioTitle}>{option.label}</span>
          </Radio>
        ))}
      </div>
    </fieldset>
  )
}

export default FormModuleRadio
